import React from 'react';
import Row from "./Row";
import Col from "./Col";

const Footer = () => {
    const version='2.11.6';

    return (
        <footer className='footer'>
            <div className={'container'}>
                <Row>
                    <Col>
                        <p>Copyright © 2025 MediCharge<span>v{version}</span></p>
                    </Col>
                </Row>
            </div>
        </footer>
    );
};

export default Footer;
